import React, { useState, useEffect } from "react";
import { Container, Card, CardBody, Button, Input, InputGroup, InputGroupText, Spinner, Row, Col, FormGroup, Label } from "reactstrap";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../Reducer/loaderSlice";
import Handler from "../Helpers/Handler";
import { useAuth } from "../Context/AuthenticateProvider";
import Logo from "../Assets/images/logo-qads.png";
import "boxicons/css/boxicons.min.css";
import { setProfile } from '../Reducer/customerSlice'

const Login = () => {

    const dispatch = useDispatch();
    const loading = useSelector(state => state.loading.loading);
    const { logIn } = useAuth();
    const [showPwd, setShowPwd] = useState(false);
    const [remember, setRemember] = useState(false);
    const [form, setForm] = useState({ email: "", password: "" });

    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem("billing_login"));
        if (saved) {
            setForm(saved);
            setRemember(true);
        }
    }, []);

    const onChange = e => setForm({ ...form, [e.target.name]: e.target.value });
    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const submit = async () => {

        if (!form.email) {
            toast.error("Email address is required");
            return;
        }
        else if (!isValidEmail(form.email)) {
            toast.error("Enter a valid email address");
            return;
        }
        else if (!form.password) {
            toast.error("Password is required");
            return;
        }
        else if (form.password.length < 6) {
            toast.error("Password must be at least 6 characters");
            return;
        }
        dispatch(loadingTrue());
        const res = await Handler({ method: "post", url: "/auth/login.php", data: form });
        if (res?.success) {
            dispatch(loadingFalse());
            if (remember) localStorage.setItem("billing_login", JSON.stringify(form));
            else localStorage.removeItem("billing_login");
            setTimeout(() => {
                logIn(res?.data?.token, res?.data?.user);
            }, 1000)
            dispatch(setProfile(res?.data?.user));
        } else {
            dispatch(loadingFalse());
            toast.error(res?.message || "Login failed");
        }
        dispatch(loadingFalse());
    };

    return (
        <div className="login-page d-flex align-items-center">
            <Container>
                <Row className="justify-content-end">
                    <Col xs={12} md={6} lg={4}>
                        <Card className="login-card">
                            <CardBody>
                                <div className="text-center mb-4">
                                    <img className="login-logo" src={Logo} alt="logo" />
                                </div>
                                <p className="text-center text-muted mb-4">Welcome to BillPro</p>
                                <Input className="mb-3" type="text" name="email" placeholder="Email address" value={form.email} onChange={onChange} />
                                <InputGroup className="mb-3">
                                    <Input type={showPwd ? "text" : "password"} name="password" placeholder="Password" value={form.password} onChange={onChange} />
                                    <InputGroupText className="cursor-pointer" onClick={() => setShowPwd(!showPwd)}>
                                        <i className={`bx ${showPwd ? "bx-show" : "bx-hide"}`}></i>
                                    </InputGroupText>
                                </InputGroup>
                                <FormGroup check className="mb-4 remember-check">
                                    <Label check className="cursor-pointer d-flex align-items-center gap-2">
                                        <Input type="checkbox" checked={remember} onChange={() => setRemember(!remember)} />
                                        Remember me
                                    </Label>
                                </FormGroup>
                                <Button className="w-100 add-btn d-flex justify-content-center align-items-center gap-2" disabled={loading} onClick={submit}>
                                    {loading && <Spinner size="sm" />}
                                    {loading ? "Logging in..." : "Login"}
                                </Button>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Login;
